import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CpiGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { CpiBrandingInfo, CpiValidateToken } from './login.models';

@Injectable({
  providedIn: 'root',
})
export class CpiService {
  constructor(private _http: HttpClient, private _gw: CpiGateway) {}

  validateToken(tokenText: string) {
    return this._http.post<CpiValidateToken>(this._gw.validateTokenUrl(), {
      validateToken: { tokenText },
    });
  }

  lyncNSync(tokenText: string) {
    return this._http.post<void>(this._gw.lyncNSyncUrl(), {
      lyncNSyncToken: { tokenText },
    });
  }

  getBranding() {
    return this._http.get<CpiBrandingInfo>(this._gw.getBrandingUrl());
  }
}
